import { useEffect, useState } from 'react';
import DropdownMenu from './Dropdowns/DropdownMenu';
import DropDownSessionMenu from './Dropdowns/DropDownSessionMenu';
import { useUser } from '../../../../../providers/UserProvider';
import magPlus from '../../pics/icons/magPlus.PNG'
import copyEncounter from '../../pics/icons/copyEncounter.png'
import OptionButton from './OptionButton';

const EncounterListTopInfo = ({streamingEncounter, setStreamingEncounter, savedEncounters, setSavedEncounters, handleLoadEncounter, currentEncounter, setCurrentEncounter, handleNewEncounter, socket}) => {
    const { username } = useUser();
    const [adminView, setAdminView] = useState(null);
    const [regEncounters, setRegEncounters] = useState([]);
    const [adminEncounters, setAdminEncounters] = useState([]);

    useEffect(() => {
        if(socket) {
            socket.on('sendAdminEncounters', (encountersResponse) => {
                encountersResponse.sort((a, b) => a.username.localeCompare(b.username));
                setRegEncounters(savedEncounters)           
                setAdminEncounters(encountersResponse)
                setSavedEncounters(encountersResponse)
            });
        }
    }, [socket]);

    const handleClick = (event) => {

        // if adminView null then get data for first adminLoad
        if(adminView === null) {
            socket.emit('getAdminEncounter')
        // if adminView true or false then data is already loaded just show it
        } else if(event.target.checked) {
            setRegEncounters(savedEncounters)
            setSavedEncounters(adminEncounters)
        } else {
            setSavedEncounters(regEncounters)
        }

        setAdminView(event.target.checked)
    }

    return (
        <div className='creatEncounterTopInfo'>
            <h3 className='titleFontFamily'>Current Encounter </h3>
            {username === 'Username' 
                ?
                    <div className='saveDisclaimer'>
                        Sign in to save Encounters
                    </div>
                : 
                    <div style={{fontSize: '10px', fontStyle: "oblique"}}> 
                        Logged in - <strong>{username}</strong>
                    </div>
            }
           
            <div className='dmViewButtonContainer'>
                <DropdownMenu adminView={adminView} streamingEncounter={streamingEncounter} savedEncounters={savedEncounters} setSavedEncounters={setSavedEncounters} setCurrentEncounter={setCurrentEncounter} handleLoadEncounter={handleLoadEncounter} currentEncounter={currentEncounter} socket={socket}/>
                <DropDownSessionMenu streamingEncounter={streamingEncounter} setStreamingEncounter={setStreamingEncounter} streamingEncounteradminView={adminView} savedEncounters={savedEncounters} socket={socket}/>
                <div className='encounterOptionsButtonContainer'>
                    <OptionButton src={magPlus} message={'New Encounter'} onClickFunction={handleNewEncounter} wrapperClassName='searchListOption' imgClassName='removeMargin'/>
                    <OptionButton src={copyEncounter} message={'Create Duplicate Encounter'} onClickFunction={() => handleNewEncounter('copy')} wrapperClassName='searchListOption' imgClassName='removeMargin'/>
                </div>
                {username === 'nicadmin' && <input type='checkbox' onClick={(event) => handleClick(event)}/>}
            </div>
        </div>
    );
}

export default EncounterListTopInfo;